module.exports = __webpack_public_path__ + "Ellipse.be9fd24.png";